module.exports = __webpack_public_path__ + "img/industry-banner-05.d80c0828.png";